<template>
    <div class="law-info">
        <law-info-card
            :refresh-count="refreshCount"
            @onBind="handleBind"
        ></law-info-card>
        <div class="bottom-container">
            <veui-carousel
                v-if="allBannerList.length"
                class="banner"
                :wrap="allBannerList.length > 1"
                :autoplay="allBannerList.length > 1"
                :interval="4000"
                :datasource="allBannerList"
                :controls="false"
                effect="slide"
                indicator-align="end"
            >
                <div slot="item" slot-scope="{pic, index}">
                    <img :src="pic" @click="handleBannerClick(index)"/>
                </div>
            </veui-carousel>
            <div class="board">
                <div class="board-box">
                    <div class="board-title">办案工具</div>
                    <div class="board-desc">本服务由北大法宝提供</div>
                </div>
                <div class="tools">
                    <div class="tools-item" @click="goto('pkuLaw', 'law')">
                        <div class="left">
                            <img
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/lawSearch-icon.png"
                                class="tool-img"
                            />
                        </div>
                        <div class="right">
                            <div class="right-top">
                                <div class="title">法规查询</div>
                                <div class="free-icon">限免</div>
                            </div>
                            <div class="desc">超<span class="num">300万</span>部规范性法律文件收录</div>
                        </div>
                    </div>
                    <div class="tools-item" @click="goto('pkuLaw', 'case')">
                        <div class="left">
                            <img
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/caseSearch-icon.png"
                                class="tool-img"
                            />
                        </div>
                        <div class="right">
                            <div class="right-top">
                                <div class="title">案例查询</div>
                                <div class="free-icon">限免</div>
                            </div>
                            <div class="desc">全国各级法院公开司法案例呈现</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="board">
                <div class="board-title">热门服务</div>
                <div class="board-power">
                    <div class="board-power-item" @click="goto('lawclues')">
                        <div class="item-icons">
                            <img
                                class="icon-img"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-clue.png" alt=""
                            />
                            <img
                                class="icon-bottom1"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-clue-bottom1.png" alt=""
                            />
                        </div>
                        <div class="text">线索认领</div>
                    </div>
                    <div class="board-power-item" @click="goto('lawquestion')">
                        <div class="item-icons">
                            <img
                                class="icon-img"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-content.png" alt=""
                            />
                            <img
                                class="icon-bottom"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-content-bottom.png" alt=""
                            />
                        </div>
                        <div class="text">内容认领</div>
                    </div>
                    <div class="board-power-item" @click="goto('offlineQa')">
                        <div class="item-icons">
                            <img
                                class="icon-img"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-answer.png" alt=""
                            />
                            <img
                                class="icon-bottom"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-answer-bottom.png" alt=""
                            />
                        </div>
                        <div class="text">问答广场</div>
                    </div>
                    <veui-popover target="boardVipItem" position="top-start">
                        <span class="help-text">
                            您可以在此购买百度律师会员服务，增加您在百度所享受的权益，包含但不限于曝光，线索，电话分佣等
                        </span>
                    </veui-popover>
                    <div
                        ref="boardVipItem"
                        class="board-power-item"
                        @click="goto('lawservice')"
                    >
                        <div class="item-icons">
                            <img
                                class="icon-img"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-vip.png" alt=""
                            />
                            <img
                                class="icon-bottom"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-vip-bottom.png" alt=""
                            />
                        </div>
                        <div class="text">我的会员</div>
                    </div>
                    <!-- eslint-disable -->
                <veui-popover target="boardPoweItem" position="top-start">
                    <span class="help-text"
                        >个人资料会展示在您的律师主页卡中，请务必填写律师本人的真实信息，便于用户在平台找到您</span
                    >
                </veui-popover>
                <div
                    ref="boardPoweItem"
                    class="board-power-item"
                    @click="goto('material')"
                >
                    <div class="item-icons">
                        <img
                            class="icon-img"
                            src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-user.png" alt=""
                        />
                        <img
                            class="icon-bottom"
                            src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/icon-user-bottom.png" alt=""
                        />
                    </div>
                    <div class="text">修改资料</div>
                </div>
                <!-- eslint-enable -->
                </div>
            </div>
            <law-footer></law-footer>
        </div>
        <bind-vip-code
            :show="isBindShow"
            title="绑定百度律师VIP会员"
            :is-firm="0"
            placeholder="请输入律师会员码"
            @closeDialog="isBindShow = false"
            @getVipInfo="getVipData"
        />
        <div v-if="showWelcomeBox" class="welcome-box">
            <div class="welcome-content">
                <div class="title">
                    恭喜您，入驻成功
                    <div class="close" @click="closeWelcomeBox('lawinfo-rzcgtc-close-btn')"><veui-icon
                        :style="{width: '20px', height: '20px', color: '#000'}" class="circle-icon"
                        name="times"
                    /></div>
                </div>
                <div class="subtitle">百度搜索「{{ showWelcomeName }}律师」即可查看您的专属百度名片</div>
                <div class="subtitle">您同时可以通过左侧菜单开始文章创作、法规/案例查询、个人信息管理，欢迎使用</div>
                <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/settle-success.png" class="welcome-image"/>
                <div class="btn">
                    <div class="i-know" @click="closeWelcomeBox('lawinfo-rzcgtc-wzdl-btn')">我知道了</div>
                    <div class="go-auth" @click="goto('material', 'jxffgrxx')">继续丰富个人信息</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file law-info.vue
 * @author baoleilei
 * @desc 我的首页
 */
import {Popover, Carousel, Icon} from 'veui';
import mixinajax from '@/mixins/ajax';
import LawFooter from '@/components/LawFooter';
import lawLinkUrl from '@/components/law-bjh-tip/lawLinkUrl';
import {mapState, mapActions, mapMutations} from 'vuex';
import BindVipCode from '@/components/bind-vip-code/bind-vip-code';
import LawInfoCard from '@/components/lawInfoCard.vue';
import {pageChange} from '@/utils/util';
import {transBDFBUrl} from '@/utils/law/toolUrl.js';
import dayjs from 'dayjs';

const url = {
    getChargeUrl: '/bp/api/mid/law_recharge',
    chargeList: '/bp/api/mid/law_queryrechargelist',
    bannerList: '/bp/api/lawyer/index/getbanner',
    listMsg: '/bp/api/msg/listMsg'
};


export default {
    name: 'info',
    mixins: [mixinajax],
    components: {
        'veui-popover': Popover,
        'veui-carousel': Carousel,
        'law-footer': LawFooter,
        'law-info-card': LawInfoCard,
        'bind-vip-code': BindVipCode,
        'veui-icon': Icon
    },
    computed: {
        ...mapState({
            userInfoNew: state => state?.lawStore?.userInfoNew,
            vipInfo: state => state.lawStore.vipInfo
        }),
        // 所有banner列表
        allBannerList() {
            const {crm_enter_type} = this.userInfoNew?.lawyer_info || {};
            if (this.vipInfo.canReceiveFreeVip && crm_enter_type === 2) {
                return [
                    {
                        handler: () => {
                            this.$wywLog.send({
                                serverId: 16844,
                                area: 'hy-banner',
                                action: 'click'
                            });
                            this.emitEvent({name: 'global_free_vip_event', payload: {
                                dialogType: 'receive'
                            }});
                        },
                        pic: 'https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/freevip-banner.png',
                        type: 'custom'
                    },
                    ...this.bannerList
                ];
            }
            return this.bannerList;
        }
    },
    watch: {
        vipInfo: {
            deep: true,
            handler(val) {
                if (val) {
                    val.vipStatusName
                        && this.$wywLog.addKey({
                            vipStatusName: val.vipStatusName || ''
                        });
                    val.canReceiveFreeVip
                        && this.$wywLog.send({
                            serverId: 16844,
                            area: 'hy-banner',
                            action: 'show'
                        });
                }
            }
        }
    },
    data() {
        return {
            consulting_info: null,
            article_info: {},
            isBindShow: false,
            bannerList: [],
            msgList: [],
            showWelcomeBox: false,
            showWelcomeName: '',
            uk: '',
            vipStatusName: '',
            refreshCount: 0 // 绑码刷新次数
        };
    },
    created() {
        this.getBanner();
        // ui未确定，先不展示，之后在专项需求里搞
        // this.getMsgList();
        const {formFirmAuth, name, vipStatusName, uk} = this.$route.query;
        if (formFirmAuth) {
            this.showWelcomeBox = true;
            this.showWelcomeName = name;
            this.vipStatusName = vipStatusName;
            this.uk = uk;
            this.$wywLog.send({
                serverId: 17245,
                action: 'show',
                page: 'lawinfo',
                area: 'lawinfo-rzcgtc',
                vipStatusName,
                uk
            });
        }
        this.$wywLog.send({
            serverId: 16509,
            page: 'lawinfo',
            action: 'show',
            area: 'homepage',
            isVip: +(this.vipInfo && this.vipInfo.vipStatus || -1)
        });
    },
    filters: {
        // 时间格式处理
        dateFilter(time) {
            if (!time) {
                return '';
            }
            return dayjs(time).format('YYYY.MM.DD');
        }
    },
    methods: {
        ...mapMutations({
            emitEvent: 'EventBus/emitEvent'
        }),
        ...mapActions({
            getVipInfo: 'lawStore/getVipInfo'
        }),
        // 刷新会员和权益信息
        getVipData() {
            this.refreshCount++;
            this.getVipInfo();
        },
        closeWelcomeBox(area) {
            this.showWelcomeBox = false;
            this.$wywLog.send({
                serverId: 17245,
                action: 'click',
                page: 'lawinfo',
                area,
                vipStatusName: this.vipStatusName,
                uk: this.uk
            });
            this.$router.replace({
                path: '/lawinfo',
                query: {}
            });
        },

        /**
         * 获取 banner
         */

        getBanner() {
            this.$http
                .get(url.bannerList, {list_type: 'pcBanner'})
                .then(res => {
                    this.bannerList = (res.data && res.data.pc_banner) || [];
                    if (this.bannerList && this.bannerList.length) {
                        this.bannerList.forEach((item, index) => {
                            this.$wywLog.send({
                                serverId: 16907,
                                area: 'pc-banner-show',
                                action: 'show',
                                name: item.name || '',
                                index
                            });
                        });
                    }
                });
        },

        goto(routerName, menu = '') {
            if (routerName === 'bjhContent') {
                // 跳转到百家号文章管理页面
                this.$store.dispatch(
                    'lawStore/openWindow',
                    lawLinkUrl.bjhContent
                );
            }
            else if (routerName === 'pkuLaw') {
                const {uk} = this.userInfoNew || {};
                const area = menu === 'law' ? 'ruleTool' : 'caseTool';
                this.$wywLog.send({
                    serverId: 16507,
                    page: 'lawinfo',
                    action: 'click',
                    area,
                    uk
                });
                this.$router.push({name: area});
            }
            else {
                if (menu === 'jxffgrxx') {
                    this.$wywLog.send({
                        serverId: 17245,
                        action: 'click',
                        page: 'lawinfo',
                        area: 'lawinfo-rzcgtc-jxffgrxx-btn',
                        vipStatusName: this.vipStatusName,
                        uk: this.uk
                    });
                }
                this.$router.push({name: routerName});
            }
        },
        getMsgList() {
            this.$http
                .get(url.listMsg, {
                    params: {
                        pn: 1,
                        rn: 10
                    }
                })
                .then(res => {
                    if (!res || +res.code !== 0) {
                        return;
                    }
                    const data = res?.data;
                    if (data && data.list && data.list.length) {
                        this.msgList = data.list.filter(item => {
                            return (
                                item.is_read
                                && dayjs(item.create_time).isAfter(
                                    dayjs().subtract(7, 'day')
                                )
                            );
                        });
                    }
                });
        },
        // 绑码
        handleBind() {
            this.$wywLog.send({
                serverId: 16844,
                area: 'home-ljbm',
                action: 'click'
            });
            this.isBindShow = true;
        },

        /**
         * 点击 banner
         * @param {Number} index 点击的是第几个 banner,从0开始
         */
        handleBannerClick(index) {
            let data = this.allBannerList[index] || {};
            this.$wywLog.send({
                serverId: 16907,
                area: 'pc-banner-click',
                action: 'click',
                name: data.name || '',
                index
            });
            // 自定义行为
            if (data.type === 'custom' && typeof data.handler === 'function') {
                data.handler();
                return;
            }
            if (!data.link) {
                return;
            }
            let url = data.link;
            // 北大法宝域名
            if (url.indexOf('pkulaw.com') !== -1) {
                url = transBDFBUrl({redirectUrl: url});
            }
            pageChange({
                type: data.type,
                url
            });
        },
        handleClickMsg(info) {
            this.$wywLog.send({
                serverId: 16940,
                area: 'msg',
                action: 'click',
                id: info.id
            });
        },
        viewMsg() {
            this.$router.push({
                name: 'lawinfo',
                query: {
                    viewMsg: true
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .veui-tooltip {
    border: 1px solid #ebeff6;
    box-shadow: 0 12px 40px 0 rgba(97, 98, 104, .1);
}
.card-title() {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #1e1f24;
    line-height: 18px;
    font-weight: 600;
}

.bottom-container {
    margin-top: 24px;
    background-color: #fff;
    padding: 30px 30px 40px;
    border-radius: 8px;
}

.help-text {
    font-size: 14px;
}

.law-info {
    .lawfooter {
        position: absolute;
        bottom: 18px;
    }

    .msg-list {
        display: flex;
        align-items: center;
        margin-top: 24px;
        padding: 15px 30px;
        background: #f1f8fe;
        box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);

        .msg-list-carousel {
            height: 20px;
            width: 100%;
            overflow: hidden;

            --dls-carousel-transition-duration: 1s;

            .msg {
                height: 20px;
                display: flex;
                align-items: center;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666;
                letter-spacing: 0;
                text-align: center;
                line-height: 14px;
                font-weight: 400;
            }

            /deep/ .veui-carousel-control {
                display: none;
            }
        }

        .icon-msg {
            width: 16px;
            height: 16px;
            margin-right: 12px;
            background:


                url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/bjh-register/icon-msg.png")
                no-repeat center / cover;
        }

        .more-btn {
            cursor: pointer;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            margin-left: auto;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #336cff;
            font-weight: 400;

            &::after {
                content: "";
                display: inline-block;
                vertical-align: middle;
                width: 8.37px;
                height: 8.37px;
                margin-left: 6px;
                background:


                    url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/bjh-register/icon-more.png")
                    no-repeat center / cover;
            }
        }
    }

    .banner {
        cursor: pointer;
        margin-bottom: 30px;
        width: 100%;
        height: 120px;
        border-radius: 8px;
        overflow: hidden;

        img {
            width: 100%;
            height: 120px;
            object-fit: cover;
            border-radius: 8px;
        }

        /deep/ .veui-carousel-control {
            display: none;
        }

        /deep/ .veui-sr-only {
            display: none;
        }

        /deep/ .veui-carousel-indicator-item {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-left: 10px;
            background-color: rgba(0, 85, 255, .2);
        }

        /deep/ .veui-carousel-indicator-item-current {
            background-color: rgba(0, 85, 255, .6);
        }
    }

    .board {
        margin-bottom: 30px;

        .board-box {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
        }

        .board-title {
            .card-title();
        }

        .board-desc {
            font-size: 14px;
            color: #848691;
        }

        .tools {
            display: flex;
            justify-content: space-between;
            margin-top: 24px;
            line-height: 1;

            .tools-item {
                cursor: pointer;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                width: 522px;
                padding: 24px;
                background: #fcfdfe;
                border-radius: 8px;
                border: 1px solid rgba(202, 219, 255, .4);

                &:hover {
                    box-shadow: 0 12px 30px 0 rgba(241, 243, 249, .9);
                }

                .left {
                    position: relative;

                    .tool-img {
                        width: 66px;
                        height: 66px;
                        border-radius: 6px;
                    }
                }

                .right {
                    margin-left: 14px;

                    .right-top {
                        display: flex;
                        align-items: center;

                        .title {
                            font-family: PingFangSC-Semibold;
                            color: #1e1f24;
                            font-size: 20px;
                            font-weight: 600;
                        }

                        .free-icon {
                            text-align: center;
                            font-size: 12px;
                            line-height: 18px;
                            font-weight: 500;
                            color: #fff;
                            background-color: #ff274b;
                            box-shadow: 0 3px 10px 0 rgba(255, 39, 75, .3);
                            border-radius: 9px;
                            width: 35px;
                            height: 18px;
                            margin-left: 6px;
                        }
                    }

                    .desc {
                        margin-top: 12px;
                        font-family: PingFangSC-Regular;
                        font-size: 16px;
                        color: #848691;

                        .num {
                            color: #1e1f24;
                        }
                    }
                }
            }
        }

        .board-power {
            font-size: 18px;
            margin-top: 24px;
            overflow: hidden;
            padding: 36px 43px 26px;
            background-color: #fcfdfe;
            border: 1px solid rgba(202, 219, 255, .4);
            border-radius: 8px;
            display: flex;
            justify-content: space-between;

            .board-power-item {
                cursor: pointer;

                &:hover {
                    .item-icons {
                        .icon-img {
                            transform: translate(-5px, -3px);
                        }

                        .icon-bottom {
                            transform: translate(5px, 3px);
                        }

                        .icon-bottom1 {
                            transform: translate(5px, 3px);
                        }
                    }
                }

                .item-icons {
                    position: relative;
                    margin-bottom: 24px;
                    display: flex;
                    justify-content: center;

                    .icon-img {
                        width: 51px;
                        height: 51px;
                        display: block;
                        transition: all .3s;
                    }

                    .icon-bottom {
                        display: block;
                        position: absolute;
                        right: 13px;
                        bottom: -2px;
                        width: 24px;
                        height: 24px;
                        object-fit: cover;
                        transition: all .3s;
                    }

                    .icon-bottom1 {
                        display: block;
                        position: absolute;
                        right: 11px;
                        bottom: -11px;
                        width: 32px;
                        height: 32px;
                        object-fit: cover;
                        transition: all .3s;
                    }
                }

                .text {
                    color: #1e1f24;
                    cursor: pointer;
                    font-size: 20px;
                    line-height: 20px;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                }
            }

            .gray {
                opacity: .5;
                cursor: no-drop;
            }
        }
    }
}

.welcome-box {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, .6);
    width: 100vw;
    height: 100vh;
    z-index: 1111;

    .welcome-content {
        width: 600px;
        height: 568px;
        background: #fff;
        box-shadow: 0 2px 20px 0 rgba(20, 26, 54, .08);
        border-radius: 4px;
        background-image: linear-gradient(180deg, #e1f8ff 0%, #fff 98px, #fff 99px);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);

        .title {
            padding-top: 30px;
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #1e1f24;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            position: relative;
            margin-bottom: 16px;

            .close {
                position: absolute;
                top: 30px;
                right: 30px;
                cursor: pointer;
            }
        }

        .subtitle {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #848691;
            line-height: 14px;
            text-align: center;
            margin-bottom: 10px;
        }

        .welcome-image {
            display: block;
            width: 293px;
            height: 300px;
            margin: 36px auto 0;
        }

        .btn {
            display: flex;
            justify-content: center;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            margin-top: 40px;

            .i-know {
                width: 200px;
                height: 44px;
                background: #fff;
                border: 1px solid #05f;
                border-radius: 4px;
                box-sizing: border-box;
                text-align: center;
                line-height: 44px;
                color: #05f;
                margin-right: 20px;
                cursor: pointer;
            }

            .i-know:hover {
                opacity: .92;
            }

            .go-auth {
                width: 200px;
                height: 44px;
                background: #05f;
                border-radius: 6px;
                box-sizing: border-box;
                text-align: center;
                line-height: 44px;
                color: #fff;
                cursor: pointer;
            }

            .go-auth:hover {
                opacity: .92;
            }
        }
    }
}
</style>
